module.exports = __webpack_public_path__ + "img/border_oblique_corner.4c1231d3.svg";